import { BusinessField } from "@/components/Sections/BusinessSlider";
import appendImageUrlFromAPI from "./appendImageUrlFromAPI";
import sanitizeDOMData from "./sanitizeDOMData";

type MediaItem = {
  type: "image" | "video";
  src: string;
  thumb?: string;
};
export const parseGallery = (item: any): MediaItem[] => {
  const gallery: MediaItem[] = [];

  // IMAGE
  if (Array.isArray(item?.add_on_data)) {
    item.add_on_data.forEach((imgItem: any) => {
      Object.keys(imgItem || {}).forEach((key) => {
        if (key.startsWith("picture") && imgItem[key]) {
          gallery.push({
            type: "image",
            // 🔥 main ảnh lớn (modal)
            src: appendImageUrlFromAPI({
              src: imgItem[key],
              size: "2k",
            }),
            // 🔥 thumbnail nhẹ
            thumb: appendImageUrlFromAPI({
              src: imgItem[key],
              size: "s",
            }),
          });
        }
      });
    });
  }

  // VIDEO
  if (Array.isArray(item?.add_on_data_2)) {
    item.add_on_data_2.forEach((videoItem: any) => {
      if (videoItem?.summary) {
        gallery.push({
          type: "video",
          src: videoItem.summary,
          thumb: appendImageUrlFromAPI({
            src: videoItem?.picture,
            size: "s",
          }),
        });
      }
    });
  }

  return gallery;
};

export const mapProcessesToBusinessFields = (data: any): BusinessField[] => {
  if (!data) return [];

  return data.map((item: any, index: number) => ({
    id: item?.id || item?.slug || index,
    title: item?.summary || "",
    desc: sanitizeDOMData(item?.content || ""),
    image: appendImageUrlFromAPI({ src: item?.picture, size: "xl" }),
    _raw: item,
  }));
};
